import gql from 'graphql-tag'

import PriceFragment from '@Queries/cms/fragments/Price.fragment'
import RecommendedProducts from '@Queries/cms/fragments/RecommendedProducts.fragment'
import AddToCartProductTacticFragment from '@Queries/tactics/AddToCartProductTactic.fragment'

export default gql`
  ${PriceFragment}
  ${AddToCartProductTacticFragment}
  ${RecommendedProducts}

  fragment TacticRecommendationsFragment on IWithRecommendations {
    recommendations @include(if: $loadRecommendations) {
      id
      title
      type
      placement
      products {
        ...RecommendedProducts
      }
    }
  }

  fragment ProductPageTacticFragment on ProductTactic {
    __typename
    ... on TacticActiveCampaign {
      id
    }
    ... on TacticBlocks {
      id
      blocks {
        ...BlockContent
      }
    }
    ... on TacticBuildYourDiscount {
      id
      products {
        id
        name
        asset {
          url
        }
        assets {
          url
        }
        variants {
          id
        }
      }
      items {
        price {
          ...PriceFragment
        }
        offers {
          productID
          offer {
            ...AddToCartProductTacticFragment
          }
        }
      }
    }
    ... on TacticBundleInfo {
      id
      bundlePrice {
        difference {
          ...MoneyContent
        }
        originalPrice {
          ...MoneyContent
        }
        price {
          ...MoneyContent
        }
      }
      bundleProducts {
        quantity
        productID
        product {
          id
          name
          type
          url
          image: asset(tag: "primary") {
            url
            dimensions {
              width
              height
            }
          }
          ...ProductSpecificationFragment
          masterVariant {
            id
            price {
              ...PriceFragment
            }
          }
        }
      }
      settings
    }
    ... on TacticComplementaryProducts {
      id
      products {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
    ... on TacticLinkedProductsColor {
      id
      color {
        type
        products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
          ...ProductCrossSellAndPersonalizationContent
        }
      }
    }
    ... on TacticLinkedProductsSizeAndVariation {
      id
      size {
        type
        products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
          ...ProductCrossSellAndPersonalizationContent
        }
      }
      variation {
        type
        products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
          ...ProductCrossSellAndPersonalizationContent
        }
      }
    }
    ... on TacticOthersBought {
      id
      ...TacticRecommendationsFragment
    }
    ... on TacticOthersBoughtGrid {
      id
      ...TacticRecommendationsFragment
    }
    ... on TacticRecommendedForYou {
      id
      ...TacticRecommendationsFragment
    }
    ... on TacticRelatedProducts {
      id
      products {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
    ... on TacticRelativeDiscount {
      id
      productIDs
      products {
        id
        name
        assets {
          url
        }
        asset {
          url
        }
      }
      relativeDiscounts {
        quantity
        price {
          format
          discount {
            format
            value
          }
          value
        }
        percentage
      }
    }
    ... on TacticSimilarProducts {
      id
      products {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
    ... on TacticUpgradeWith {
      id
      items {
        type
        product {
          ...ProductCrossSellAndPersonalizationContent
        }
      }
    }
  }
`
